// フレスタ固有のFeatureFlagsを作成します。
// これらのフラグはServiceSpecificationにprotoフィールドが存在しないため、
// siteTypeの判定で値を切り替えます。
// 注意: 非フレスタパートナーではすべてfalseで上書きされます。
// 将来他パートナーでこれらのフラグを有効化する場合は、
// ServiceSpecificationへの移行またはこの関数の条件分岐の変更が必要です。
import { EcSite } from '@apis/type/ec_site_pb'

export function createPartnerConfigFeatureFlagsFrestaPart(siteType: EcSite.SiteType) {
  const isFresta = siteType === EcSite.SiteType.FRESTA
  return {
    get enableSubscriptionV2(): boolean {
      return isFresta
    },
    get enableCompensationClame(): boolean {
      return isFresta
    },
    get enableReservationProduct(): boolean {
      return isFresta
    },
    get enableProcurement(): boolean {
      return isFresta
    },
    get enableDeliveryVouchers(): boolean {
      return isFresta
    },
    get enableRecurringOrder(): boolean {
      return isFresta
    },
    // フレスタ固有機能でフレスタ以外では利用しない
    get enableCatalog(): boolean {
      return isFresta
    },
  }
}
